export const PHONE_REGEXP = /^\+[1-9][0-9]{5,}$/;
export const PHONE_REGEXP_WITHOUT_PREFIX = /^[0-9]{5,}$/;

export const QUICKBOOKS_CHARACTERS = /^[\w,.?@&!#~ _\-;+]*$/;

export const EMAIL_REGEXP =
    /^([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)+$/; // eslint-disable-line
